module.exports = __webpack_public_path__ + "static/img/car3.86b22de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car3.png
// module id = TGed
// module chunks = 1